<template>
  <div class="tr" :data-kind="kind" data-test="trigger-settings">
    <SettingsCard
      v-if="kind === 'mangovoice'"
      title="Trigger"
      description="Select which Mango Voice event should trigger this workflow."
    >
      <FieldRow label="Event type">
        <WfPicker
          v-model="p.mangoEventTypeObj"
          :options="wfBuilder.mangoEventTypeOptions"
          :searchable="false"
          :show-labels="false"
          label="text"
          track-by="value"
          placeholder="Select event type…"
          @input="onEvent"
        />
      </FieldRow>
    </SettingsCard>

    <SettingsCard v-else-if="kind === 'xfollowups'" title="Trigger">
      <FieldRow
        label="Trigger after X follow-ups"
        help="The workflow will trigger after this many followups are completed."
        for-id="tr-followup-count"
      >
        <input
          id="tr-followup-count"
          v-model="p.followupCount"
          type="number"
          min="1"
          class="tr__input"
          placeholder="Enter number of followups"
          data-test="trigger-followup-count"
        />
      </FieldRow>
    </SettingsCard>
  </div>
</template>

<script>
/**
 * The settings of the two triggers that have any (design frame 1o):
 *   mangovoice  the Mango Voice event type: `mangoEventTypeObj` (+ `onMangoEventTypeSelect`, which writes
 *               `mangoEventType`);
 *   xfollowups  the number of follow-ups to wait for: `followupCount`.
 *
 * ⛔ No prop named patNum / siteID / loading / allSettings / isSuperAdmin / userID.
 */
import FieldRow from './FieldRow.vue';
import SettingsCard from './SettingsCard.vue';
import WfPicker from './WfPicker.vue';

export default {
  name: 'TriggerSettings',
  components: { FieldRow, SettingsCard, WfPicker },
  inject: ['wfBuilder'],

  props: {
    /** 'mangovoice' | 'xfollowups' */
    kind: { type: String, required: true },
  },

  computed: {
    p() {
      return (this.wfBuilder.selectedNodeData || {}).properties || {};
    },
  },

  methods: {
    onEvent(val) {
      this.wfBuilder.onMangoEventTypeSelect(val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../workflow-tokens';

.tr {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tr__input {
  @include wf-field(42px);
  max-width: 240px;
}
</style>
